import React, { useState } from 'react'
import GenericModal from '../../../../components/modal/GenericModal';
import InputText from '../../../../components/modalComponents/InputText';
import InputSelect from '../../../../components/modalComponents/InputSelect';
import TransferList from '../../components/TransferList';

// ──────────────────────────────────────────────────────────────────────────
// Modal chico "Nueva pregunta" / "Editar pregunta" (paso 4 — Feedback, boceto
// compartido por Jody, 26/08/2026). Pregunta (texto) + Tipo (Abierta/Cerrada).
// Si Tipo="Cerrada" se muestra el selector de doble lista (TransferList) para
// elegir, del maestro de alternativas (`catalogoAlternativas`, ver nota sobre
// DataType Discriminator='TP_AlternativasPregunta' en modelo-datos-notas.md),
// cuáles quedan asignadas a esta pregunta puntual.
//
// Sin backend todavía: `onSave` le devuelve el objeto de la pregunta al
// estado de FeedbackStep.jsx — cuando exista el API real esto pasa a guardar
// TP_ConvocatoriaPregunta (+ TP_AlternativaPregunta por cada seleccionada).
// ──────────────────────────────────────────────────────────────────────────

const TIPO_PREGUNTA_OPTIONS = [
    { value: "A", label: "Abierta" },
    { value: "C", label: "Cerrada" },
];

const PreguntaFormModal = ({ toggleModal, pregunta, catalogoAlternativas, onSave }) => {
    const isEditing = !!pregunta;
    const [texto, setTexto] = useState(pregunta?.Texto ?? "");
    const [tipoPregunta, setTipoPregunta] = useState(pregunta?.TipoPregunta ?? "A");

    const alternativasYaSeleccionadas = catalogoAlternativas.filter(a => pregunta?.Alternativas?.some(sel => sel.value === a.value));
    const [seleccionadas, setSeleccionadas] = useState(alternativasYaSeleccionadas);
    const [disponibles, setDisponibles] = useState(catalogoAlternativas.filter(a => !alternativasYaSeleccionadas.some(sel => sel.value === a.value)));

    const handleChangeTipo = (e) => {
        setTipoPregunta(e.target.value.value);
    }

    const handleTransferChange = ({ available, selected }) => {
        setDisponibles(available);
        setSeleccionadas(selected);
    }

    const handleSubmit = () => {
        if (!texto?.trim()) return;
        onSave({
            ...pregunta,
            Texto: texto,
            TipoPregunta: tipoPregunta,
            Alternativas: tipoPregunta === "C" ? seleccionadas : [],
        });
        toggleModal();
    }

    return (
        <GenericModal showModal={toggleModal} titulo={isEditing ? "Editar pregunta" : "Nueva pregunta"} width="700px">
            <div className="modal-body">
                <InputText label="Pregunta" name="Texto"
                    value={texto}
                    onChange={(e) => setTexto(e.target.value)}
                    direction="column" isRequired />

                <InputSelect label="Tipo" name="TipoPregunta"
                    options={TIPO_PREGUNTA_OPTIONS}
                    value={TIPO_PREGUNTA_OPTIONS.find(o => o.value === tipoPregunta)}
                    onChange={handleChangeTipo}
                    direction="column" isRequired />

                {tipoPregunta === "C" &&
                    <div className="mt-3">
                        <TransferList available={disponibles} selected={seleccionadas} onChange={handleTransferChange} />
                    </div>
                }

                <div className="d-flex justify-content-center mt-4">
                    <button type="button" className="btn generic-button-buscador generic-button-hover-verde green-innova-background" onClick={handleSubmit}>
                        {isEditing ? "Guardar" : "Agregar"}
                    </button>
                </div>
            </div>
        </GenericModal>
    )
}

export default PreguntaFormModal
